import { render, staticRenderFns } from "./IconSearchPlus.vue?vue&type=template&id=91a38192&scoped=true&"
import script from "./IconSearchPlus.vue?vue&type=script&lang=js&"
export * from "./IconSearchPlus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91a38192",
  null
  
)

export default component.exports